import { t } from 'i18next';

import { ErrorResponseErrorItemCodeGeoid } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeGeoid, string> => ({
  'geoid:not_found': t('geoid.notFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Geoiden existerar inte.',
  }),
  'geoid:invalid': t('geoid.invalid', {
    ns: 'apiErrorCodes',
    defaultValue: 'Geoiden är inte en giltig GeoTIFF-fil.',
  }),
});
